import React from 'react'

export const BrPrimitive = props => {
    return (
        <React.Fragment>
            <br />
            <br />
        </React.Fragment>
    )
}